import IconCancel from '@pages/Payment/Components/IconCancel'
import { detectEnvUat, formatMoney } from '@utils/general'
import { Modal } from 'antd'
import QRCode from 'qrcode'
import React, { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { RootState } from 'store'
import { Type_Initstate } from 'store/appSlice'
import { IResponePVCB } from '../../../../types/general'
import DownloadQrImage from './DownloadQrImage'
import QrExpiryNotice from './QrExpiryNotice'

interface IProps {
  img?: IResponePVCB | undefined
  isModalOpen: boolean
  expiresAtMs?: number
  allowCancel?: boolean
  isSkipSelectBill?: boolean
  setIsModalOpen: (value: boolean) => void
}

const ModalPVCB: FC<IProps> = ({
  isModalOpen,
  img,
  setIsModalOpen,
  allowCancel,
  isSkipSelectBill,
  expiresAtMs,
}: IProps) => {
  const navigate = useNavigate()
  const params = useParams()
  const [qrImage, setQrImage] = useState<string>('')
  const appState = useSelector<RootState, Type_Initstate>((state) => state.app)

  useEffect(() => {
    let active = true
    setQrImage('')
    if (!img?.qrCodeText) {
      return
    }

    QRCode.toDataURL(img.qrCodeText)
      .then((url) => {
        if (active) {
          setQrImage(url)
        }
      })
      .catch((err) => {
        console.error(err)
      })
    return () => {
      active = false
    }
  }, [img?.qrCodeText])

  const handleOk = () => {
    setIsModalOpen(false)
  }
  const handleNavigate = () => {
    navigate(
      `${detectEnvUat() ? '/uat' : ''}/organization/${params.orgCode}/school/${params.schoolCode}/student/${
        params.studentID
      }`,
    )
  }

  const handleCancel = () => {
    if (allowCancel) {
      setIsModalOpen(false)
    } else if (window.confirm('Phiếu thu chỉ có thể tạo lại sau 15 phút. Bạn có muốn thoát !')) {
      setIsModalOpen(false)
      if (isSkipSelectBill && appState?.studenInfor?.redirect_success.length > 0) {
        window.location.replace(appState?.studenInfor?.redirect_success)
      } else {
        handleNavigate()
      }
    }
  }

  return (
    <>
      {img && (
        <Modal
          title={<></>}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={<></>}
          className="p-0 custom-modal rouder-31"
        >
          <div className="border-[25px] border-[#045993] rounded-[20px] px-[12px] py-[16px]">
            <div className="relative items-center flex flex-col justify-center rounded-[20px] ">
              <span className="absolute right-[-8px] top-[-8px]">
                <IconCancel
                  handleCancel={() => {
                    handleCancel()
                  }}
                />
              </span>
              <img src={require('@assets/icon/PVCB.png')} alt="" className="w-[135px] h-full" />
              <div className="border-[1px] border-[#151515] my-[8px] mt-[36px] mx-[12px]">
                <img src={qrImage} alt="" className="mx-auto w-full " />
              </div>
              <DownloadQrImage imageSrc={qrImage} fileName="pvcb-qr-thanh-toan.png" />
            </div>
            <div className="mb-1">
              <p className="text-center text-[16px] font-[400] text-[#26538c] pb-1 mt-3">Tên trường: {img?.school}</p>

              <p className="text-center text-[16px] font-[400] text-[#26538c] pb-3">
                Số tiền: {formatMoney(img?.amount)} VND
              </p>
              <QrExpiryNotice
                isModalOpen={isModalOpen && !!qrImage && !!img?.qrCodeText}
                paymentChannel="PVCB"
                resetKey={img?.transactionCode}
                expiresAtMs={expiresAtMs}
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  )
}
export default ModalPVCB
